import React from 'react';
import { Box, Typography, Grid2, Paper, useTheme } from '@mui/material';
import Section from './Section';

const SeccionCambiarEstado = () => {
  const theme = useTheme();

  const steps = [
    { label: 'Accede a tu rifa', description: 'Abre la app y selecciona la rifa en la que deseas realizar cambios.' },
    { label: 'Pestaña Ventas', description: 'Ve a la sección Ventas para ver el estado de cada número.' },
    { label: 'Localiza el número', description: 'Encuentra el boleto por su número o nombre de comprador.' },
    { label: 'Abre el menú (...)', description: 'Toca los tres puntos a la derecha del registro.' },
    { label: 'Selecciona el nuevo estado', description: 'Cambia entre Disponible, Reservado o Pagado, o marca el ganador.' },
    { label: 'Guarda los cambios', description: 'El comprador recibirá su actualización por WhatsApp automáticamente.' },
  ];

  return (
    <Section
      title="Cambiar Estado de un Boleto"
      subtitle="Actualiza fácilmente el estado de cualquier número cuando recibas el comprobante de pago:"
      hasBackground={true}
      id="cambiar-estado"
    >
      <Grid2 container spacing={2}>
        {steps.map((step, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              elevation={0}
              sx={{
                p: 2.5,
                height: '100%',
                borderRadius: '12px',
                bgcolor: theme.palette.background.paper,
                border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.06)',
                display: 'flex',
                gap: 1.8,
                alignItems: 'flex-start',
                boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 2px 6px rgba(26, 31, 82, 0.03)',
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.4)' : 'rgba(45, 52, 132, 0.2)',
                  transform: 'translateY(-2px)',
                  boxShadow: theme.palette.mode === 'dark' ? '0 6px 16px rgba(0, 0, 0, 0.4)' : '0 6px 16px rgba(45, 52, 132, 0.06)',
                },
              }}
            >
              {/* Badge numerado idéntico a rauh-rifas */}
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  fontSize: '0.85rem',
                  fontWeight: 900,
                  bgcolor: theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.16)' : 'rgba(45, 52, 132, 0.08)',
                  color: theme.palette.mode === 'dark' ? '#818cf8' : theme.palette.primary.main,
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  mt: 0.2,
                }}
              >
                {index + 1}
              </Box>
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: theme.palette.text.primary, mb: 0.5 }}>
                  {step.label}
                </Typography>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, lineHeight: 1.5 }}>
                  {step.description}
                </Typography>
              </Box>
            </Paper>
          </Grid2>
        ))}
      </Grid2>
    </Section>
  );
};

export default SeccionCambiarEstado;